import axios from 'axios'
import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {API_URL} from '../../../_metronic/helpers'
import {isDemoInstall} from '../../../_metronic/helpers/brand'

type ResetState = 'idle' | 'sending' | 'requested' | 'failed'

/**
 * The demo install's strip at the top of every panel page (user decisions 2026-11-01): nothing here reaches the tax
 * organisation, and «بازنشانی دمو» puts the sample data back before a meeting. The database server does the reset, so the
 * page only says it is on its way; the sign-out that follows brings everyone to the sign-in page.
 */
export const DemoBanner: FC = () => {
  const [confirming, setConfirming] = useState(false)
  const [state, setState] = useState<ResetState>('idle')

  if (!isDemoInstall) return null

  const requestReset = async () => {
    setState('sending')
    try {
      await axios.post(`${API_URL}/demo/reset`)
      setState('requested')
      setConfirming(false)
    } catch {
      setState('failed')
    }
  }

  return (
    <div className='bg-warning-subtle border-bottom border-warning px-4 py-3' role='status'>
      <div className='d-flex flex-wrap align-items-center justify-content-between gap-3'>
        <div className='d-flex align-items-start gap-3'>
          <i className='las la-flask fs-1 text-warning-emphasis' aria-hidden='true' />
          <div>
            <strong className='d-block text-warning-emphasis'>نسخهٔ نمایشی</strong>
            <span className='text-gray-800'>
              کسب‌وکارها و صورتحساب‌ها نمونه‌اند و هیچ چیزی به سازمان امور مالیاتی فرستاده نمی‌شود. پیامک و پرداخت هم
              واقعی نیستند. داده‌ها هر شب ساعت ۳ به حالت اول برمی‌گردند.
            </span>
            {state === 'requested' && (
              <small className='d-block text-gray-700 fw-bold mt-1'>
                بازنشانی ثبت شد و تا حدود یک دقیقهٔ دیگر انجام می‌شود؛ بعد از آن دوباره وارد شوید.
              </small>
            )}
          </div>
        </div>
        <button
          type='button'
          className='btn btn-sm btn-dark'
          disabled={state === 'requested'}
          onClick={() => {
            setState('idle')
            setConfirming(true)
          }}
        >
          <i className='las la-undo-alt fs-4' aria-hidden='true' /> بازنشانی دمو
        </button>
      </div>

      <Modal
        show={confirming}
        onHide={() => state !== 'sending' && setConfirming(false)}
        centered
        aria-labelledby='demo-reset-title'
      >
        <Modal.Header>
          <Modal.Title as='h2' id='demo-reset-title'>
            بازنشانی دمو
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='mb-0'>
            همهٔ تغییرات این نسخهٔ نمایشی پاک می‌شود و داده‌های نمونه به حالت اول برمی‌گردد. هر کسی که الان داخل دموست هم
            بیرون می‌افتد و باید دوباره وارد شود.
          </p>
          {state === 'failed' && (
            <div className='text-danger fw-bold mt-3' role='alert'>
              درخواست بازنشانی ثبت نشد؛ لطفاً دوباره تلاش کنید.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-light'
            disabled={state === 'sending'}
            onClick={() => setConfirming(false)}
          >
            انصراف
          </button>
          <button type='button' className='btn btn-danger' disabled={state === 'sending'} onClick={requestReset}>
            {state === 'sending' ? 'در حال ثبت…' : state === 'failed' ? 'تلاش مجدد' : 'بازنشانی'}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
